import './StatCard.css';
import CountUpValue from '../CountUpValue/CountUpValue';

export default function StatCard({ icon, value, title, category }) {
  return (
    <div className="StatCard">
      <div className="StatCard__iconWrap">
        {icon ? (
          <img
            className="StatCard__icon"
            src={icon}
            alt=""
            aria-hidden="true"
          />
        ) : null}
      </div>
      <div className="StatCard__content">
        <CountUpValue className="StatCard__value" value={value} />
        <div className="StatCard__title">{title}</div>
        <div className="StatCard__category">{category}</div>
      </div>
    </div>
  );
}
